import { ImageClass } from './component/ImageClass';

export const vars = ImageClass.cssVarList;

const image = {};

export default image;
